import React, {useEffect, useState} from 'react';
import {Button, Col, Row} from 'antd';
import {Arguments} from '../common/Arguments';
import {RealtimeGetMethod} from '../common/ApiMethod';
import {handleExport} from '../common/ExportDataToExcelComponent';

const UnitMembers = () => {
	const getApi = Arguments.host + '/society_organization/society/api!memberCompany.do';
	const unitApi = Arguments.host + '/society_organization/home/api!organizationAndUnit.do';
	const [data, setData] = useState([]);

	useEffect(() => {
		RealtimeGetMethod(unitApi).then(allData => setData(allData));
	}, [getApi]);

	const exportMethod = () => {
		RealtimeGetMethod(unitApi).then(allData => {
			const filteredData = allData?.map(
				(
					{
						organization_name,
						member_unit_name,
						member_unit_attribute,
						member_unit_post,
						member_unit_corporation,
						member_unit_count,
						member_unit_meeting_people,
						member_unit_meeting_people_phone,
					},
				) =>
					(
						{
							'组织名称': organization_name,
							'单位名称': member_unit_name,
							'单位性质': member_unit_attribute,
							'社团职务': member_unit_post,
							'法人': member_unit_corporation,
							'单位人数': member_unit_count,
							'参会代表': member_unit_meeting_people,
							'联系电话': member_unit_meeting_people_phone,
						}
					),
			);
			handleExport(filteredData);
		});
	};

	return (
		<Row>
			<Col span={3} style={{
				textAlign: 'right',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end',
			}}>社团单位会员：</Col>
			<Col span={1} style={{
				textAlign: 'left',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end',
			}}>{data?.length}</Col>
			<Col span={20} style={{textAlign: 'left'}}>
				<Button type="link" onClick={() => exportMethod()}>【导出】</Button>
			</Col>
		</Row>
	);
};

export default UnitMembers;
